import React, { forwardRef, useState, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import cloneDeep from 'lodash.clonedeep';
import Form, { FieldUpdateHandlerParam } from 'shared/form';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import { AccessFunctionInterfaceFormData } from 'data/accessFunction/accessFunction.types';
import './file-import-export-form.scss';

type IpAddressType = {
    ipAddr: string,
    prefix: string,
}

type Props = {
    data: AccessFunctionInterfaceFormData[],
    template: FormTemplate,
    i18nKeyPrefix: string,
    isEditing?: boolean,
    onClickFileAction: (param: string) => void,
    mode: 'create' | 'edit' | 'copy' | 'view',
}

export type Ref = {
    getValues: (keepOPeration: boolean) => IpAddressType[]
}

const FileImportExportForm = forwardRef<Ref, Props>(({
    onClickFileAction,
    mode,
}: Props, ref) => {
    const { t } = useTranslation();

    return (
      <div className="file-import-export-form">
        <Button className="file-import-export-form-button" onClick={() => onClickFileAction('import')} disabled={mode !== 'edit'}>Import</Button>
        <Button className="file-import-export-form-button" onClick={() => onClickFileAction('export')} disabled={mode !== 'edit'}>Export</Button>
      </div>
    )
});

export default FileImportExportForm;
